(function () {
	"use strict";

	var sidebar = document.getElementById("sidebar-menu");
	if (!sidebar) return;

	function headerGroupSections() {
		return Array.prototype.filter.call(document.body.children, function (el) {
			return el.classList && el.classList.contains("shopify-section-group-header-group");
		});
	}

	function pinHeaderGroup() {
		var sections = headerGroupSections();
		var offset = 0;
		var zIndex = sections.length + 3;

		for (var i = 0; i < sections.length; i++) {
			var el = sections[i];
			el.style.setProperty("position", "sticky", "important");
			el.style.setProperty("top", offset + "px", "important");
			el.style.setProperty("transform", "none", "important");
			el.style.setProperty("z-index", String(zIndex), "important");
			zIndex -= 1;
			offset += el.offsetHeight;

			if (el.classList.contains("shopify-section--header")) break;
		}

		document.documentElement.style.setProperty("--mobile-nav-top-offset", offset + "px");
	}

	function unpinHeaderGroup() {
		headerGroupSections().forEach(function (el) {
			el.style.removeProperty("position");
			el.style.removeProperty("top");
			el.style.removeProperty("transform");
			el.style.removeProperty("z-index");
		});
		document.documentElement.style.removeProperty("--mobile-nav-top-offset");
	}

	new MutationObserver(function () {
		if (sidebar.hasAttribute("open")) {
			pinHeaderGroup();
		} else {
			unpinHeaderGroup();
		}
	}).observe(sidebar, { attributes: true, attributeFilter: ["open"] });
})();
